import { GroupsIcon, DollarIcon, CheckIcon } from '@/components/Icons';
import {
  Header,
  BackgroundGradient,
  StyledHeadingDesktop,
  StyledHeadingMobile,
} from '@/components/ItineraryCheckoutHeader/styles';
import { ItineraryCheckoutStepButton } from '@/components/ItineraryCheckoutStepButton/ItineraryCheckoutStepButton';
import { pages } from '@/hooks/useItineraryNavigation';
import { theme as themeObject } from '@/styles/theme';

function CurvedLine() {
  return (
    <svg width="100%" viewBox="0 0 300 200" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M 0 200 Q 150 130 300 200"
        stroke={themeObject.color.tertiary}
        fill="transparent"
        strokeDasharray="5,5"
      />
    </svg>
  );
}

export function ItineraryCheckoutHeader() {
  return (
    <BackgroundGradient>
      <Header>
        <ItineraryCheckoutStepButton to="overview" icon={<CheckIcon />}>
          <StyledHeadingDesktop>{pages.overview.name}</StyledHeadingDesktop>
          <StyledHeadingMobile>{pages.overview.name}</StyledHeadingMobile>
        </ItineraryCheckoutStepButton>
        <CurvedLine />
        <ItineraryCheckoutStepButton to="travelParty" icon={<GroupsIcon />}>
          <StyledHeadingDesktop>{pages.travelParty.name}</StyledHeadingDesktop>
          <StyledHeadingMobile>{pages.travelParty.name}</StyledHeadingMobile>
        </ItineraryCheckoutStepButton>
        <CurvedLine />
        <ItineraryCheckoutStepButton to="payment" icon={<DollarIcon />}>
          <StyledHeadingDesktop>{pages.payment.name}</StyledHeadingDesktop>
          <StyledHeadingMobile>{pages.payment.name}</StyledHeadingMobile>
        </ItineraryCheckoutStepButton>
      </Header>
    </BackgroundGradient>
  );
}
